import { initSentry } from '@hh.ru/front-static-app';

import serviceName from 'src/modules/serviceName';
import { initUxfeedback } from 'src/modules/uxfeedback';

import 'src/app/global.less';

if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}

initSentry(serviceName);

const init = require('src/app/App').default;

initUxfeedback();

export default init;
